/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskWithSubtasksResponseDto } from '../../models/core-project-task-with-subtasks-response-dto';

export interface ProjectTasksControllerFindOneComplete$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the project task to retrieve.
 */
  id: string;
}

export function projectTasksControllerFindOneComplete(http: HttpClient, rootUrl: string, params: ProjectTasksControllerFindOneComplete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectTaskWithSubtasksResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerFindOneComplete.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectTaskWithSubtasksResponseDto>;
    })
  );
}

projectTasksControllerFindOneComplete.PATH = '/o2-core/project-tasks/{tenant}/{id}/complete';
